import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectTriggerOverview } from "../../CommonComponents/CommonProjectTriggerViews";
export const ProjectTriggerBuiltInFeedNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().builtInFeedTriggerNew,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTriggerOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
